const getters = {
  token: state => state.user.token,
  staffId: state => state.user.staffId,
  nickname: state => state.user.nickname,
  phone: state => state.user.phone,
}
export default getters
